import { render, staticRenderFns } from "./FormButtons.vue?vue&type=template&id=0e8ee787&"
import script from "./FormButtons.vue?vue&type=script&lang=js&"
export * from "./FormButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e8ee787')) {
      api.createRecord('0e8ee787', component.options)
    } else {
      api.reload('0e8ee787', component.options)
    }
    module.hot.accept("./FormButtons.vue?vue&type=template&id=0e8ee787&", function () {
      api.rerender('0e8ee787', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/FormButtons.vue"
export default component.exports